import { useEffect, useState } from 'react';
import { Mail, MessageSquare } from 'lucide-react';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { ART } from '../lib/art';

export default function Help() {
  const [tab, setTab] = useState('faq');
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
      <div className="badge-cozy mb-3">Help</div>
      <h1 className="text-4xl sm:text-5xl font-heading font-semibold mb-6">Hi 👋 What can we help with?</h1>
      <div className="flex gap-2 mb-8 border-b border-[#3f2e1e] pb-3 flex-wrap">
        <button className={`chip ${tab==='faq'?'active':''}`} onClick={()=>setTab('faq')} data-testid="help-tab-faq">FAQ</button>
        <button className={`chip ${tab==='about'?'active':''}`} onClick={()=>setTab('about')} data-testid="help-tab-about">About us</button>
        <button className={`chip ${tab==='contact'?'active':''}`} onClick={()=>setTab('contact')} data-testid="help-tab-contact">Contact us</button>
      </div>
      {tab==='faq' && <FAQ/>}
      {tab==='about' && <About/>}
      {tab==='contact' && <Contact/>}
    </div>
  );
}

function FAQ() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(0);
  useEffect(() => { api.get('/faq').then(r => setItems(r.data)); }, []);
  return (
    <div className="space-y-2">
      {items.map((q, i) => (
        <button key={q.faq_id} onClick={()=>setOpen(open===i?-1:i)} className="block w-full text-left magical-card p-4" data-testid={`faq-${i}`}>
          <div className="flex items-center justify-between">
            <span className="font-heading text-base">{q.question}</span>
            <span className="text-[#f97316] text-xl">{open===i ? '−' : '+'}</span>
          </div>
          {open===i && <p className="text-[#a3a3a3] mt-3 text-sm leading-relaxed">{q.answer}</p>}
        </button>
      ))}
    </div>
  );
}

function About() {
  return (
    <div className="space-y-6">
      <div className="magical-card p-6 flex items-center gap-5">
        <img src={ART.coffee} alt="" className="w-24 hidden sm:block"/>
        <div>
          <h3 className="font-heading text-xl mb-1">Why Ghostie exists</h3>
          <p className="text-[#a3a3a3] text-sm leading-relaxed">Travel is more fun when you meet real locals — not someone reading a script. Ghostie connects you with vetted enthusiasts of folklore, mystery and dark travel for a 2–6 hour private hangout.</p>
        </div>
      </div>
      <div className="magical-card p-6">
        <div className="text-xs uppercase font-accent text-[#f97316] tracking-widest mb-1">Founder</div>
        <div className="font-heading text-xl mb-2">Gwen</div>
        <p className="text-[#a3a3a3] text-sm leading-relaxed">A travel expert who spent years in tourism and wanted something more personal than standard sightseeing. Ghostie launched in 2026.</p>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        {[['🛡️','Vetted','Application + interview + ID check'],['🔒','Safe','Public meeting points only'],['💸','Fair','Hosts get €30/hr · €10 bonus for 5★']].map(([e,t,d])=>(
          <div key={t} className="magical-card p-4"><div className="text-2xl mb-1">{e}</div><div className="font-heading">{t}</div><p className="text-xs text-[#a3a3a3]">{d}</p></div>
        ))}
      </div>
    </div>
  );
}

function Contact() {
  const [f, setF] = useState({ name:'', email:'', subject:'', message:'' });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post('/contacts', f); setSent(true); }
    catch { toast.error('Failed'); }
  };
  if (sent) return <div className="magical-card p-8 text-center"><div className="text-5xl mb-2">📬</div><h3 className="font-heading text-xl">Got it. We'll reply soon.</h3></div>;
  return (
    <div className="grid sm:grid-cols-[1fr_2fr] gap-4">
      <div className="magical-card p-4 text-sm">
        <div className="flex items-center gap-2 mb-2"><Mail size={14} className="text-[#f97316]"/><a href="mailto:hello@ghostie.it" className="link-soft">hello@ghostie.it</a></div>
        <div className="flex items-center gap-2"><MessageSquare size={14} className="text-[#f97316]"/><span>We reply within 24h.</span></div>
      </div>
      <form onSubmit={submit} className="magical-card p-5 space-y-3">
        <input required className="input-cozy" placeholder="Your name" value={f.name} onChange={e=>setF(s=>({...s,name:e.target.value}))} data-testid="contact-name"/>
        <input required type="email" className="input-cozy" placeholder="Email" value={f.email} onChange={e=>setF(s=>({...s,email:e.target.value}))} data-testid="contact-email"/>
        <input required maxLength={50} className="input-cozy" placeholder="Subject" value={f.subject} onChange={e=>setF(s=>({...s,subject:e.target.value}))} data-testid="contact-subject"/>
        <textarea required rows={4} className="input-cozy" placeholder="Your message" value={f.message} onChange={e=>setF(s=>({...s,message:e.target.value}))} data-testid="contact-message"/>
        <button className="btn-primary" data-testid="contact-submit">Send</button>
      </form>
    </div>
  );
}
